interface Callback {
	(data: any): void;
}

export abstract class Emitter {
	private _callbacks: { [key: string]: Callback[] } = {};

	protected constructor() {}

	public on = (event: string, fn: Callback) => {
		(this._callbacks['$' + event] = this._callbacks['$' + event] || []).push(fn);
	};

	protected emit = (event: string, data: any) => {
		let callbacks = this._callbacks['$' + event];

		if (callbacks) {
			for (let fn of callbacks.slice(0)) {
				fn(data);
			}
		}
	};
}
